module.exports = __webpack_public_path__ + "fonts/Marianne-Medium.f3bef09.otf";